<template>
  <div>
    <!-- サイドメニュー -->
    <v-navigation-drawer v-model="drawer" class="green lighten-3" app width="300">
      <v-container>
        <v-list-item >
            <div class="usr-name">氏名：{{ menuInfo1 }}<br/>{{ menuInfo2 }}</div>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense nav>
          <!-- ホーム -->
          <v-list-item @click="transScreen('ホーム')">
            <v-list-item-icon>
              <v-icon>mdi-home-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>ホーム</v-list-item-title>
          </v-list-item>
          <!-- 受付申請一覧検索 -->
          <v-list-item @click="transScreen('受付申請一覧検索')">
            <v-list-item-icon>
              <v-icon>mdi-text-box-search-outline </v-icon>
            </v-list-item-icon>
            <v-list-item-title>受付申請一覧検索</v-list-item-title>
          </v-list-item>
          <!-- マスタ -->
          <v-list-group :value="false" prepend-icon="mdi-account-circle">
            <template v-slot:activator>
              <v-list-item-title>マスタ</v-list-item-title>
            </template>
            <v-list-item v-for="menuInfo in menuMasterList" :key="menuInfo.name" @click="clickMenuAction(menuInfo.name, menuInfo.link, menuInfo.newWindowFlg)">

              <v-list-item-content>
                <v-list-item-subtitle class="menu-title">{{ menuInfo.name }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>{{ menuInfo.icon }}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>
          <!-- ログアウト -->
          <v-list-item @click="transScreen('ログアウト')">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>ログアウト</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-container>
    </v-navigation-drawer>
    <!-- グローバルナビゲーション -->
    <v-app-bar app color="#FFFFFF">
      <v-app-bar-nav-icon @click="drawer = !drawer"> </v-app-bar-nav-icon>
      <v-toolbar-title>
        <div class="scn-name">{{ toolbarTitle }}</div>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-spacer></v-spacer>
      <div>
        <v-img class = "tqslogo" src="../assets/img/honnin-sev-title.png" @click="transScreen('トップページ')"></v-img>
      </div>
    </v-app-bar>
     <!-- その他 -->
    <comMessageConfirm :msg="dlgMsgLogoutConfirm.msg" :isOpen="dlgMsgLogoutConfirm.isOpen" :doYes="dlgMsgLogoutConfirm.doYes" :doNo="dlgMsgLogoutConfirm.doNo" />
  </div>

</template>
<script>
export default {
  props: ["propScreenTitle", "propMenuInfo1", "propMenuInfo2", "propSrcScreenId"],
  name: "VFHeaderAuth",
  data() {
    return {
      screenTitle: "ページヘッダ",
      screenId: "VFC100",
      drawer: false,
      menuMasterList: [
        { name: "　確認ユーザ新規登録", icon: "mdi-account-reactivate-outline",
         link: this.$router.resolve({ name: "VFU200", params: {srcScreenId: this.propSrcScreenId} }).href, newWindowFlg: false },
        { name: "　確認ユーザ一覧検索", icon: "mdi-account-search-outline",
         link: this.$router.resolve({ name: "VFU100", params: {srcScreenId: this.propSrcScreenId} }).href, newWindowFlg: false },
        
      ],
      transViewPath: "",
      dlgMsgLogoutConfirm: {
        msg: "",
        isOpen: false,
        doYes: () => {
          // // 編集状態初期化
          // this.$store.commit("requestRegInfo/resetState");
          // 認証初期化
          this.$store.commit("vfAuthcUser/resetState");
          // 次画面遷移
          this.$router.push(this.transViewPath);
        },
        doNo: () => {
          this.dlgMsgLogoutConfirm.isOpen = false;
        },
      },
    };
  },
   computed: {
    toolbarTitle() {
      return this.propScreenTitle;
    },
    menuInfo1() {
      return this.propMenuInfo1;
    },
    menuInfo2() {
      return this.propMenuInfo2;
    },
    sourceScreenUrl() {
      return this.propSrcScreenId;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    /*
    * 初期表示
    */
    initialize: function () {

     },

    /*
    * 画面遷移
    */
    transScreen: function(name) {
       // 遷移先
      if (name == 'ログアウト' || name == 'トップページ') {  
        this.transViewPath = this.$router.resolve({ name: "VFA100" }).href;
      } else if (name == 'ホーム') {
        this.transViewPath = this.$router.resolve({ name: "VFV100" }).href;
      } else if (name == '受付申請一覧検索') {
        this.transViewPath = this.$router.resolve({ name: "VFV200", params: {srcScreenId: this.propSrcScreenId} }).href;
      }

      if (name == 'ログアウト' || name == 'トップページ') {
        // 確認メッセージ表示
        this.dlgMsgLogoutConfirm.msg = this.$i18n.t('msg.wrn.ps010');
        this.dlgMsgLogoutConfirm.isOpen = true;
      } else {
        // 遷移
        this.$router.push(this.transViewPath).catch(()=>{});
      }
     },

/**
     * メニュー押下
     */
    clickMenuAction(name, action, newWindowFlg) {
      // 遷移先URL
      this.transViewPath = action;
      if (newWindowFlg) {
        window.open(action, '_blank', 'noreferrer');
      }else{
        // 遷移
        this.$router.push(action).catch(()=>{});
      }
    }


  },
}
</script>
<style scoped>
.scn-name {
  font-size: x-large;
  color: #43A047;
}

.tqslogo {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: 10%;
  left: 80%;
  width: 185px;
  height: auto;
}

</style>
